import { FormattedMessage, useIntl } from "react-intl";

import LayerMenuCalculationLayer from "./LayerMenuCalculationLayer";
import LayerMenuCalculationLayerTwoDWaterflows from "./LayerMenuCalculationLayerTwoDWaterflows";
import LayerMenuCalculationLayerWaterflows from "./LayerMenuCalculationLayerWaterflows";
import LayerSubMenu from "./LayerSubMenu";

const LayerMenuCalculationSubmenu = () => {
  const intl = useIntl();

  return (
    <LayerSubMenu>
      <LayerSubMenu.Header>
        <FormattedMessage id="layerMenu.calculationHeader" defaultMessage="Calculation" />
      </LayerSubMenu.Header>

      <LayerSubMenu.ItemList>
        <LayerMenuCalculationLayer
          calculationLayerType={"Water Depth"}
          calculationDisplayType={intl.formatMessage({
            id: "layerMenu.water_depth_title",
            defaultMessage: `Water depth`,
          })}
        />
        <LayerMenuCalculationLayerWaterflows />
        <LayerMenuCalculationLayerTwoDWaterflows />
        <LayerMenuCalculationLayer
          calculationLayerType={"Model grid"}
          calculationDisplayType={intl.formatMessage({
            id: "layerMenu.model_grid_title",
            defaultMessage: `Model grid`,
          })}
        />
      </LayerSubMenu.ItemList>
    </LayerSubMenu>
  );
};

export default LayerMenuCalculationSubmenu;
